import { render } from "./ViewBlog.vue?vue&type=template&id=4079b1f6&scoped=true"
import script from "./ViewBlog.vue?vue&type=script&lang=js"
export * from "./ViewBlog.vue?vue&type=script&lang=js"

import "./ViewBlog.vue?vue&type=style&index=0&id=4079b1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4079b1f6"]])

export default __exports__